import { DxButtonModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsPopUpButtonComponent } from './settings-pop-up-button.component';



@NgModule({
  declarations: [
    SettingsPopUpButtonComponent
  ],
	exports: [
		SettingsPopUpButtonComponent,
	],
  imports: [
    CommonModule,

		DxButtonModule,
  ]
})
export class SettingsPopUpButtonModule { }
